const state = {
  user: {
    name: '',
    role: ''
  }
}

const mutations = {
  setUser (state, { usr_nm, perfil }) {
    state.user.name = usr_nm
    state.user.role = perfil
  },
  unsetData (state) {
    state.user = {
      name: '',
      role: ''
    }
  }
}

const actions = {
  newUser ({ commit }, data) {
    commit('setUser', data)
  },
  clearData ({ commit }) {
    commit('unsetData')
  }
}

const getters = {
  user: (state) => state.user
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
